import React, { Component } from 'react';
import fetcher from '../API';
import _ from 'lodash';
import CommonHeader from "./CommonHeader";
import CreatableSelector from "./CreatableSelector";
import { message } from 'antd';

class ProductShortTitle extends Component {
    constructor(props) {
        super(props);

        const { id } = this.props.product;

        this.state = {
            errorResponse: '',
            shortTitle: '',
            productIdList: [id],
            contentPids: [],
        }
        this.saveShortTitleToServer = this.saveShortTitleToServer.bind(this)
    }
    saveShortTitleToServer() {
        let productIdList = this.getContentData()
        let { shortTitle } = this.state
        fetcher.post(`/api/v1/products/_batch/short/title`, {
            productIds: productIdList, shortTitle: shortTitle
        }).then((response) => {
            if(response.data.productIds.length > 0) {
                this.setState({
                    errorResponse: '以下productID提交失败：' + response.data.productIds
                })
            } else {
                this.setState({
                    errorResponse: ''
                })
            }
            message.success('提交成功');
        }).catch(error => {
            alert(error);
        });
    }
    getContentData = () => {
        let pIds = this.state.productIdList;
        if (this.state.contentPids && this.state.contentPids.length > 0) {
            pIds = pIds.concat(this.state.contentPids.map(pids => pids.value));
        }
        for(let i = 0; i < pIds.length; i++) {
            pIds[i] = pIds[i].replace(/^\s*|\s*$/g,"");
        }
        return pIds
    }
    onChangeContentPids = (contentPids) => {
        this.setState({
            contentPids: contentPids || [],
        })
    }
    render() {
        let { shortTitle, errorResponse } = this.state
        return (
            <div>
                <div>
                    <CommonHeader className="col-md-12 mb-1"
                        headerTitle={ '同时更新其它商品(填入 product id)：' }/> 
                    <CreatableSelector
                        values={ this.state.contentPids }
                        onSelect={ this.onChangeContentPids }
                    />
                    <span></span>
                </div>
                <div className="mt-3">
                    {
                        errorResponse && <div className="alert alert-warning alert-dismissible" role="alert">
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <strong>Warning!</strong> {errorResponse}
                        </div>
                    }
                    
                </div>
                <div className="mt-3">
                    <CommonHeader className="col-md-12 mb-1"
                        headerTitle={'商品短标题'}
                        buttonTitle={'Submit'}
                        buttonAction={this.saveShortTitleToServer} />
                    <div className="col-md-12">
                        <input className="form-control"
                            onChange={(event) => { this.setState({ shortTitle: event.target.value }) }}
                            value={shortTitle} />
                    </div>
                </div>
            </div>
        );
    }
}
export default ProductShortTitle;